/**
 * Consolidated constants module for group-tickets
 */
export const selectors = {
    form: '.group-tickets-form-wrapper',
    formClass: 'group-tickets-form-wrapper',
    starPriceClass: 'has-star-price-selection',
    calendarModal: '#group-ticket-calendar',
};

// Hooks
const NS = 'group-tickets';

export const HOOKS = {
    // Preference updates
    PREF_TRANSFORM: `${NS}/preference/transform`,
    PREF_UPDATED: `${NS}/preference/updated`,
    PREF_EVENT_SELECTED: `${NS}/preference/event-selected`,
    STAR_PRICE_STATUS_CHANGED: `${NS}/star-price-status-changed`,
};

// Templates
const blackoutIcon = html`
    <span class="icon text--secondary-light">
        <svg><use xlink:href="#icon-x-circle"></use></svg>
    </span>
`;
const studentIcon = html`
    <span class="icon text--secondary-light">
        <svg><use xlink:href="#icon-diamond"></use></svg>
    </span>
`;

export function getLegendTemplate() {
    return html`
        <span>${studentIcon} Student Pricing</span>
        <span>${blackoutIcon} Blackout Dates</span>
    `;
}

export function getEventDecoration(event) {
    if (event.availability === 'sold_out') {
        return blackoutIcon;
    }
    if (event.availability === 'best') {
        return studentIcon;
    }
    return '';
}
